// ThankYouModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ThankYouModal = ({ 
  show, 
  onClose, 
  message = "Ad Updated Successfully!",
  subMessage = "Your advertisement has been updated"
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered
    >
      <Modal.Header 
        style={{
          borderBottom: 'none', 
          padding: '25px 25px 0',
          display: 'block',
          position: 'relative'
        }}
      >
        <button 
          type="button" 
          className="btn-close" 
          onClick={handleClose}
          style={{
            position: 'absolute',
            right: '15px',
            top: '15px'
          }}
        ></button>
        <Modal.Title 
          style={{
            fontSize: '28px', 
            fontWeight: '700', 
            color: '#2D3748', 
            textAlign: 'center', 
            width: '100%',
            margin: '0',
            padding: '0 40px'
          }}
        >
          Thank You!
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body 
        style={{
          padding: '25px', 
          textAlign: 'center'
        }}
      >
        <h4 
          style={{
            color: '#FD7E14', 
            marginBottom: '15px', 
            fontSize: '22px', 
            fontWeight: '600',
            lineHeight: '1.3'
          }}
        >
          {message}
        </h4>
        <p 
          style={{
            color: '#4A5568', 
            marginBottom: '5px', 
            lineHeight: '1.6',
            fontSize: '16px',
            fontWeight: '500'
          }}
        >
          {subMessage}
        </p>
      </Modal.Body>
      
      <Modal.Footer 
        style={{
          borderTop: 'none', 
          padding: '15px 25px 25px', 
          justifyContent: 'center'
        }}
      >
        <Button
          variant="primary"
          onClick={handleClose}
        
          style={{
            backgroundColor: '#FD7E14',
            borderColor: '#FD7E14',
            color: 'white',
            padding: '12px 40px',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '16px',
            minWidth: '140px',
            boxShadow: '0 2px 4px rgba(253, 126, 20, 0.3)',
            border: 'none',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#e5690c';
            e.target.style.borderColor = '#e5690c';
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '0 4px 8px rgba(253, 126, 20, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#FD7E14';
            e.target.style.borderColor = '#FD7E14';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 4px rgba(253, 126, 20, 0.3)';
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ThankYouModal;